const SoundCloudIcon = ({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) => {
  return (
    <span className={'flex items-center ' + className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 19) / 18}
        viewBox='0 0 18 19'
        fill='currentColor'
      >
        <path d='M0.561963 9.33536C0.252625 9.33536 0 9.59583 0 9.91805V13.4186C0 13.7409 0.253484 14.0004 0.561963 14.0004C0.870442 14.0004 1.12479 13.7409 1.12479 13.4186V9.91805C1.12479 9.59583 0.871302 9.33536 0.561963 9.33536Z' />
        <path d='M7.31257 5.25203C7.00323 5.25203 6.74975 5.5116 6.74975 5.83472V14.0013C6.74975 14.3235 7.00238 14.584 7.31257 14.584C7.62277 14.584 7.8754 14.3244 7.8754 14.0013V5.83472C7.8754 5.5125 7.62191 5.25203 7.31257 5.25203Z' />
        <path d='M5.06145 7.58459C4.75211 7.58459 4.49862 7.84416 4.49862 8.16638V13.9995C4.49862 14.3217 4.75211 14.5822 5.06145 14.5822C5.37078 14.5822 5.62427 14.3226 5.62427 13.9995V8.16638C5.62427 7.84774 5.37078 7.58459 5.06145 7.58459Z' />
        <path d='M2.81213 7.58459C2.50279 7.58459 2.24931 7.84416 2.24931 8.16638V13.9995C2.24931 14.3217 2.50279 14.5822 2.81213 14.5822C3.12147 14.5822 3.37496 14.3226 3.37496 13.9995V8.16638C3.37496 7.84774 3.12147 7.58459 2.81213 7.58459Z' />
        <path d='M15.1876 8.75264C14.9874 8.75264 14.7898 8.77412 14.6007 8.8153C14.3472 6.16411 12.1853 4.08398 9.56279 4.08398C9.25345 4.08398 8.99997 4.34445 8.99997 4.66667V13.9977C8.99997 14.3199 9.25345 14.5804 9.56279 14.5804H15.1876C16.7377 14.5804 18 13.2727 18 11.6652C18 10.0577 16.7377 8.75354 15.1876 8.75354V8.75264Z' />
      </svg>
    </span>
  );
};

export default SoundCloudIcon;
